<div class="chat-vreq" [class.chat-vreq--closed]="closed">
  <div class="chat-vreq__head">
    <span class="chat-vreq__icon"><chat-icon name="clock" [size]="15"></chat-icon></span>
    <span class="chat-vreq__title">{{ strings.visitRequestTitle }}</span>
  </div>
  <p *ngIf="params.note" class="chat-vreq__note">{{ params.note }}</p>
  <p *ngIf="canAnswer && !closed" class="chat-vreq__text">{{ strings.visitRequestText }}</p>
  <div class="chat-vreq__slots">
    <button *ngFor="let s of slots; trackBy: trackBySlot" type="button" class="chat-vreq__slot"
      [class.chat-vreq__slot--on]="s.iso === params.chosen" [disabled]="!canAnswer || closed" (click)="choose.emit(s.iso)">
      <chat-icon *ngIf="s.iso === params.chosen" name="check" [size]="13"></chat-icon>{{ s.label }}
    </button>
  </div>
  <div *ngIf="proposing" class="chat-vreq__propose">
    <input type="date" class="chat-vreq__input" [(ngModel)]="proposeDate">
    <input type="time" class="chat-vreq__input" [(ngModel)]="proposeTime">
    <button type="button" class="chat-vreq__btn chat-vreq__btn--primary" [disabled]="!proposeDate || !proposeTime" (click)="confirmPropose()">
      {{ strings.proposeConfirm }}
    </button>
    <button type="button" class="chat-vreq__btn" (click)="proposing = false">{{ strings.cancel }}</button>
  </div>
  <div class="chat-vreq__status" [class.chat-vreq__status--ok]="params.status === 'scheduled' || params.status === 'chosen' || params.status === 'scheduling'"
    [class.chat-vreq__status--warn]="params.status === 'proposed' || !!params.conflict" [class.chat-vreq__status--off]="params.status === 'declined'">
    <span *ngIf="scheduling" class="chat-vreq__spinner" aria-hidden="true"></span>{{ statusText }}
  </div>
  <!-- staff: um clique para marcar o horário escolhido / aceitar o proposto; ou propor outros -->
  <div *ngIf="!proposing && canSchedule && pickedIso && !closed" class="chat-vreq__actions">
    <button type="button" class="chat-vreq__btn chat-vreq__btn--primary" [disabled]="busy" (click)="schedule.emit(pickedIso)">
      <span *ngIf="busy" class="chat-vreq__spinner chat-vreq__spinner--light" aria-hidden="true"></span>
      <chat-icon *ngIf="!busy" name="check" [size]="13"></chat-icon>{{ scheduleLabel }}
    </button>
    <button type="button" class="chat-vreq__btn" [disabled]="busy" (click)="proposeOther.emit()">{{ strings.proposeOther }}</button>
  </div>
  <!-- quem responde em nome do cliente (não usado no CRM) -->
  <div *ngIf="!proposing && canAnswer && !closed" class="chat-vreq__actions">
    <button type="button" class="chat-vreq__btn" (click)="startPropose()">{{ strings.proposeOther }}</button>
    <button type="button" class="chat-vreq__btn chat-vreq__btn--muted" (click)="decline.emit()">{{ strings.declineRequest }}</button>
  </div>
</div>
